define('mapi',['require'],function (require) {
    'use strict';
    
    var AndroidMobile = function(){};
    AndroidMobile.prototype = {
        send: function(payload){
            Android.postMessage(JSON.stringify(payload));
        }
    };
    
    var IOSMobile = function(){};
    IOSMobile.prototype = {
        send: function(payload){
            window.webkit.messageHandlers.observe.postMessage(payload);
        }
    };
    
    var WebMobile = function(){};
    WebMobile.prototype = {
        send: function(payload){
            console.log(payload);
        }
    };
    
    var Mapi = function(){
        var mobile = null;
        if (typeof Android !== "undefined") {
            this.mobile = new AndroidMobile();
        } else if (typeof window.webkit !== "undefined" && typeof window.webkit.messageHandlers !== "undefined" && typeof window.webkit.messageHandlers.observe !== "undefined"){
            this.mobile = new IOSMobile();
        } else {
            this.mobile = new WebMobile();
        }
    };
    Mapi.prototype = {
        trackScreen: function(name, cust_dim){
            this.mobile.send({
                "action": "track-screen",
                "param": {
                    "name": name,
                    "custom_dim": cust_dim
                }
            });
        },
        trackEvent: function(param){
            this.mobile.send({
                "action": "track-event",
                "param": param
            });
        }
    };
    
    return Mapi;
        
});
